<template>
    <div class="flex justify-content-center align-items-center w-full">
        <div class="register-page  w-full md:w-8 lg:w-8">
            <h1 class="text-center Paragraph-Medium">
                {{ authStore.userType === 'student' ? 'Your path to academic success starts here' :
                    authStore.userType === 'tutor' ? 'Join with us to become a verified tutor' :
                        authStore.userType === 'institute' ? 'Join with us to become an institution' :
                            '' }}
            </h1>

            <div class="flex flex-column ustify-content-center align-items-center py-4">
                <Button label="Continue with Google" icon="pi pi-google" iconPos="left"
                    class="google-button Paragraph-Medium" @click="googleSignup" />
                <label class="pt-4 Caption">or</label>
            </div>
            <Form v-slot="$form" @submit="handleRegister" :initialValues="initialValues" :resolver="resolver"
                class="register-form justify-content-center align-items-center">

                <div class="flex flex-column gap-3">
                    <label for="username" class="Label align-self-start">{{ authStore.userType ===
                        'institute' ?'Institution Name':'Full Name'}}</label>
                    <IconField class="w-full">
                        <InputIcon class="pi pi-user" />
                        <InputText id="username" name="username" type="text"
                            :placeholder="authStore.userType === 'institute' ? 'Enter institution name here' : 'Enter full name here'"
                            size="small" variant="filled" class="w-full" />
                    </IconField>
                    <Message v-if="$form.username?.invalid" severity="error" size="small" variant="simple">
                        {{ $form.username?.error.message }}
                    </Message>
                </div>


                <div class="flex flex-column gap-3 pt-4">
                    <label for="email" class="Label align-self-start">Email</label>
                    <IconField class="w-full">
                        <InputIcon class="pi pi-envelope" />
                        <InputText id="email" v-model="emailValue" name="email" type="email"
                            placeholder="Enter email here" size="small" variant="filled"
                            :class="['w-full', { 'p-invalid': emailValidation.isChecked && !emailValidation.isValid }]"
                            @blur="handleEmailBlur" />
                    </IconField>
                </div>

                <div class="flex flex-column gap-3 pt-4" v-if="authStore.userType === 'institute'">
                    <label for="brc" class="Label align-self-start">BRC</label>
                    <IconField class="w-full">
                        <InputIcon class="pi pi-user" />
                        <InputText id="brc" name="brc" type="text" placeholder="Enter BRC here" size="small"
                            variant="filled" class="w-full" />
                    </IconField>
                    <Message v-if="$form.brc?.invalid" severity="error" size="small" variant="simple">
                        {{ $form.brc?.error.message }}
                    </Message>
                </div>

                <div class="flex flex-column gap-3 pt-4">
                    <label for="password" class="Label align-self-start">Password</label>
                    <IconField iconPosition="left" class="w-full">
                        <InputIcon class="pi pi-lock" />
                        <Password id="password" name="password" toggleMask placeholder="Enter password here"
                            size="small" variant="filled" class="w-full" :feedback="false"
                            promptLabel="Choose a strong password" weakLabel="Weak" mediumLabel="Medium"
                            strongLabel="Strong" />
                    </IconField>
                    <Message v-if="$form.password?.invalid" severity="error" size="small" variant="simple">
                        {{ $form.password.error.message }}
                    </Message>
                </div>


                <div class="flex flex-column w-full py-4">
                    <div class="flex  items-start gap-2">
                        <Checkbox v-model="termsChecked" :class="authStore.userType === 'tutor' ? 'teal-checkbox' : authStore.userType === 'institute' ? 'yellow-checkbox' :
                            authStore.userType === 'student' ? 'orange-checkbox' : ''" binary
                            inputId="terms" />
                        <label for="terms" class="Caption text-left flex-1">
                            Yes, I understand and agree to the
                            <!-- <a href="#" class="Caption-teal">Terms of Service</a>, including -->
                            <router-link to="/termsOfService" class="Caption-teal">Terms of Service</router-link>,
                            the User Agreement and Privacy Policy.
                        </label>
                    </div>
                </div>
                <Message v-if="!termsChecked && formSubmitted" severity="error" size="small" variant="simple"
                    class="w-full">
                    You must accept the Terms of Service to register.
                </Message>


                <div class="flex flex-column align-items-center gap-3 pt-4">
                    <Button type="submit" :class="authStore.userType === 'student' ? 'orange-button' :
                        authStore.userType === 'tutor' ? 'teal-button' :
                            authStore.userType === 'institute' ? 'teal-button' : 'teal-button'"
                        :disabled="loading || keycloakRole === null || !termsChecked || !$form.valid">
                        {{ loading ? "Creating..." : "Create my account" }}
                    </Button>
                    <label class="Caption pt-2">
                        Already have an account?
                        <span class=" cursor-pointer" :class="authStore.userType === 'student' ? 'Caption-orange' :
                            authStore.userType === 'tutor' ? 'Caption-teal' :
                                authStore.userType === 'institute' ? 'Caption-teal' :
                                    'Caption-teal'" @click="goToLogin">
                            Login
                        </span>
                    </label>
                </div>

                <Dialog v-model:visible="otpDialogVisible" modal header="Verify your email" :style="{ width: '30rem' }">
                    <div class="flex flex-column gap-3">
                        <p class="m-0 Caption text-left">
                            A 6-digit OTP has been sent to
                            <strong>{{ pendingRegistrationData?.email || emailValue }}</strong>.
                            Enter the code below to continue.
                        </p>
                        <div class="flex justify-content-center">
                            <InputOtp v-model="otpInput" integerOnly :length="6" variant="filled" />
                        </div>
                        <Message v-if="otpErrorMessage" severity="error" size="small" variant="simple">
                            {{ otpErrorMessage }}
                        </Message>
                        <div class="flex justify-content-between align-items-center gap-2">
                            <Button label="Request new OTP" text size="small" @click="requestNewOtp"
                                :disabled="otpRequesting || !pendingRegistrationData?.email" />
                            <Button label="Verify" class="orange-button" @click="confirmOtpAndRegister"
                                :loading="otpVerifying" :disabled="otpInput.length < 6" />
                        </div>
                    </div>
                </Dialog>

                <!-- Disclaimer -->
                <div v-if="authStore.userType === 'student'" class="text-center w-full pt-6 pb-2">
                    <h3 class="text-lg font-semibold mb-2" style="color: #dc2626;">Disclaimer</h3>
                    <p class="text-700 text-sm m-0">
                        Our platform integrates with Google Meet for online classes. For the best experience, we recommend signing up using a Google account.
                    </p>
                </div>
                <div v-else-if="authStore.userType === 'tutor'" class="text-center w-full pt-6 pb-2">
                    <h3 class="text-lg font-semibold mb-2" style="color: #1FC9A3;">Disclaimer</h3>
                    <p class="text-700 text-sm m-0">
                        For the best experience with Google Meet classes, we recommend signing in with a Google account.
                    </p>
                </div>
            </Form>
        </div>
    </div>
</template>

<script setup>
import { ref, reactive, defineEmits, onMounted, watch } from "vue";
import { useAuthStore, setRememberMe } from "@/stores/authStore";
import { Form } from "@primevue/forms";
import Dialog from "primevue/dialog";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";
import InputOtp from "primevue/inputotp";
import InputText from "primevue/inputtext";
import Password from "primevue/password";
import Button from "primevue/button";
import Checkbox from "primevue/checkbox";
import Message from "primevue/message";
import { verifyEmail } from "@/api/auth";
import { notifyError } from '@/utils/notification';
import { useRouter } from "vue-router";

const router = useRouter();
const authStore = useAuthStore();

const loading = ref(false);
const termsChecked = ref(false);
const formSubmitted = ref(false);
const keycloakRole = ref(null);
const emailValue = ref("");
const otpDialogVisible = ref(false);
const otpInput = ref("");
const otpErrorMessage = ref("");
const pendingRegistrationData = ref(null);
const sentOtpCode = ref("");
const otpRequesting = ref(false);
const otpVerifying = ref(false);
const emailValidation = ref({
    isChecking: false,
    isVerified: false,
    isValid: false,
    isChecked: false,
    message: "",
    severity: "info"
});
const verifiedEmailCache = ref(null);
let emailValidationTimer = null;

const initialValues = reactive({
    username: "",
    email: "",
    password: "",
    brc: ""
});

const emit = defineEmits(["registration-success",]);

onMounted(async () => {
    keycloakRole.value = await authStore.findKeycloackRole(authStore.userType);
});

const googleSignup = async () => {
    const res = await authStore.googleAuthSignup(JSON.stringify(keycloakRole.value));
    const url = res.data.data;
    window.location.href = url;
}

const performRegister = async (values) => {
    loading.value = true;
    try {
        const res = await authStore.register({
            username: values.username,
            email: values.email,
            password: values.password,
            role: keycloakRole.value,
            brc: values.brc || null,
        });
        setRememberMe(true);
        await authStore.login(values.email, values.password, true);
        emit("registration-success", res.data.data);
    } catch (error) {
        const errorMsg = error.response?.data?.message || error.message || "Registration failed. Please try again.";
        notifyError("Error", errorMsg);
    } finally {
        loading.value = false;
    }
};

const requestOtpCode = async (email) => {
    const normalizedEmail = (email || "").trim();
    if (!normalizedEmail) {
        notifyError("Error", "Please enter a valid email address.");
        return false;
    }

    otpRequesting.value = true;
    try {
        const response = await verifyEmail(normalizedEmail);
        const data = response?.data?.data;
        const receivedOtp = String(data?.otp ?? "").trim();

        if (!receivedOtp) {
            throw new Error("OTP was not returned from the server.");
        }

        sentOtpCode.value = receivedOtp;
        otpInput.value = "";
        otpErrorMessage.value = "";
        return true;
    } catch (error) {
        const errorMsg = error.response?.data?.message || error.message || "Unable to send OTP. Please try again.";
        notifyError("Error", errorMsg);
        return false;
    } finally {
        otpRequesting.value = false;
    }
};

const requestNewOtp = async () => {
    if (!pendingRegistrationData.value?.email) return;
    const otpSent = await requestOtpCode(pendingRegistrationData.value.email);
    if (otpSent) {
        otpDialogVisible.value = true;
    }
};

const confirmOtpAndRegister = async () => {
    if (!pendingRegistrationData.value) return;

    const enteredOtp = String(otpInput.value || "").trim();
    if (!enteredOtp) {
        otpErrorMessage.value = "Please enter the OTP code sent to your email.";
        return;
    }

    if (enteredOtp !== sentOtpCode.value) {
        otpErrorMessage.value = "OTP is not correct.";
        return;
    }

    otpVerifying.value = true;
    try {
        otpDialogVisible.value = false;
        await performRegister(pendingRegistrationData.value);
    } finally {
        otpVerifying.value = false;
    }
};

const handleRegister = async (values) => {
    formSubmitted.value = true;
    if (!termsChecked.value) return;

    const { errors } = resolver(values);
    if (Object.keys(errors).length > 0) return;

    const normalizedEmail = (values.values.email || "").trim();
    if (!normalizedEmail) {
        notifyError("Error", "Please enter a valid email address.");
        return;
    }

    pendingRegistrationData.value = {
        username: values.values.username,
        email: normalizedEmail,
        password: values.values.password,
        brc: values.values.brc || null,
    };

    const otpSent = await requestOtpCode(normalizedEmail);
    if (otpSent) {
        otpDialogVisible.value = true;
    }
};

const resetEmailValidation = () => {
    verifiedEmailCache.value = null;
    emailValidation.value = {
        isChecking: false,
        isVerified: false,
        isValid: false,
        isChecked: false,
        message: "",
        severity: "info"
    };
};

const isEmailSyntaxValid = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const applyCachedEmailValidation = (normalizedEmail) => {
    if (!verifiedEmailCache.value) return false;

    const cachedEmail = verifiedEmailCache.value.email?.toLowerCase();
    if (cachedEmail !== normalizedEmail.toLowerCase()) return false;

    emailValidation.value = {
        ...verifiedEmailCache.value.state,
        isChecked: true
    };
    return true;
};

const saveEmailValidationResult = (normalizedEmail, state) => {
    verifiedEmailCache.value = {
        email: normalizedEmail,
        state: { ...state }
    };
    emailValidation.value = { ...state, isChecked: true };
};

const validateEmailAddress = async (email) => {
    const normalizedEmail = email.trim();

    if (!normalizedEmail) {
        resetEmailValidation();
        return;
    }

    if (!isEmailSyntaxValid(normalizedEmail)) {
        emailValidation.value = {
            isChecking: false,
            isVerified: false,
            isValid: false,
            isChecked: true,
            message: "",
            severity: "error"
        };
        return;
    }

    const nextState = {
        isChecking: false,
        isVerified: true,
        isValid: true,
        isChecked: true,
        message: "",
        severity: "success"
    };

    saveEmailValidationResult(normalizedEmail, nextState);
};

const handleEmailBlur = () => {
    const normalizedEmail = emailValue.value.trim();
    if (!normalizedEmail) {
        resetEmailValidation();
        return;
    }

    if (!isEmailSyntaxValid(normalizedEmail)) {
        emailValidation.value = {
            isChecking: false,
            isVerified: false,
            isValid: false,
            isChecked: true,
            message: "",
            severity: "error"
        };
        return;
    }

    clearTimeout(emailValidationTimer);
    validateEmailAddress(normalizedEmail);
};

watch(emailValue, (newValue) => {
    clearTimeout(emailValidationTimer);
    const normalizedEmail = newValue.trim();

    if (!normalizedEmail) {
        resetEmailValidation();
        return;
    }

    if (!isEmailSyntaxValid(normalizedEmail)) {
        emailValidation.value = {
            isChecking: false,
            isVerified: false,
            isValid: false,
            isChecked: true,
            message: "",
            severity: "error"
        };
        return;
    }

    if (applyCachedEmailValidation(normalizedEmail)) return;

    emailValidation.value = {
        isChecking: true,
        isVerified: false,
        isValid: false,
        isChecked: false,
        message: "",
        severity: "info"
    };

    emailValidationTimer = setTimeout(() => {
        validateEmailAddress(normalizedEmail);
    }, 700);
});

const resolver = ({ values }) => {
    const errors = {};

    if (!values.username) {
        errors.username = [{ message: "Full Name is required." }];
    }

    if (!values.email) {
        errors.email = [{ message: "Email is required." }];
    } else if (!isEmailSyntaxValid(values.email)) {
        errors.email = [{ message: "Please enter a valid email address." }];
    }

    if (!values.password) {
        errors.password = [{ message: "Password is required." }];
    } else if (values.password.length < 6) {
        errors.password = [{ message: "Password must be at least 6 characters." }];
    }

    return { values, errors };
};

const goToLogin = () => {
    router.push('/login')
};


</script>

<style scoped>
.register-page {
    background: #fff;
}

.google-button {
    background-color: white;
    color: var(--gray-600);
    border: 1px solid #ddd;
    padding: 8px 40px 8px 40px;
}

.google-button:hover {
    background-color: var(--gray-50) !important;
    color: var(--gray-600) !important;
    border: 1px solid #ddd !important;
}

@media (max-width: 768px) {
    .register-page {
        width: 100%;
        margin-bottom: 1rem;
        padding: 1.5rem;
    }
}
</style>
